import { Box } from '@chakra-ui/react';
import * as React from 'react';

const CardBody = (props) => <Box {...props} />;

export default CardBody;
